import { isOptgroup, isOption, Optgroup, Option } from "components/input/select/options";

export class OptionIterator {
    public static find(options: Array<Option | Optgroup>, callback: (Option) => boolean): Option {
        for (let option of options) {
            if (isOption(option) && callback(option)) {
                return option;
            }
            if (isOptgroup(option) && option.options != null) {
                return OptionIterator.find(option.options, callback);
            }
        }
    }

    public static filterFlat(options: Array<Option | Optgroup>, callback: (Option) => boolean): Option[] {
        let filtered = [];
        for (let option of options) {
            if (isOption(option) && callback(option)) {
                filtered.push(option);
            }
            if (isOptgroup(option) && option.options != null) {
                let recursed = OptionIterator.filterFlat(option.options, callback);
                filtered = filtered.concat(recursed);
            }
        }
        return filtered;
    }
}
